'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _cart = require('./cart');

var _confirmation = require('./confirmation');

var _order = require('./order');

var _cartProduct = require('./components/cart-product');

var _cartTotalPriceDiscounts = require('./components/cart-total-price-discounts');

var _cartBySellers = require('./components/cart-by-sellers');

var _cartError = require('./cart-error');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO FIX STATE NAME WITH CAMELCASE!
var _module = _angular2.default.module('app.checkout', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('cart', {
        parent: 'general',
        url: '/cart?productId',
        views: {
            'main@root': {
                component: 'checkoutCart'
            }
        },
        reloadOnSearch: true,
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Your shopping cart" | translate}}'
        }
    }).state('checkout-order', {
        parent: 'cart',
        url: '/order',
        views: {
            'main@root': {
                component: 'checkoutOrder'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': ''
        },
        resolve: {
            wholeSalers: ["cartService", function wholeSalers(cartService) {
                return cartService.getWholesalers().then(function (whole) {
                    var febelco = {
                        id: 22168,
                        isFebelcoCustomerWholesaler: true,
                        isDisabled: true,
                        name: 'Febelco'
                    };
                    whole.push(febelco);
                    return whole;
                });
            }],
            customerAccounts: ["cartService", function customerAccounts(cartService) {
                return cartService.getCustomerAccounts().then(function (response) {
                    return response && response.accounts || [];
                });
            }],
            cart: ["cartService", function cart(cartService) {
                return cartService.checkout();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Order" | translate}}'
        }
    }).state('order-draft', {
        parent: 'cart',
        url: '/order-draft',
        views: {
            'main@root': {
                component: 'checkoutOrderDraft'
            }
        },
        params: {
            loadingOverlay: true
        }
    }).state('checkout-confirmation', {
        parent: 'cart',
        url: '/confirmation',
        views: {
            'main@root': {
                component: 'checkoutConfirmation'
            }
        },
        resolve: {
            orders: ["$state", "$stateParams", "$timeout", "$q", function orders($state, $stateParams, $timeout, $q) {
                // when there is no orders in the stateParams, go to the order overview
                if ($stateParams.orders && $stateParams.orders.length > 0) {
                    return $stateParams.orders;
                } else {
                    $timeout(function () {
                        return $state.go('order-overview', $stateParams);
                    }, 0);
                    return $q.reject();
                }
            }],
            disabledSellers: ["$stateParams", function disabledSellers($stateParams) {
                return $stateParams.disabledSellers;
            }]
        },
        params: {
            orders: null,
            disabledSellers: null,
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Thank you for ordering" | translate}}'
        }
    }).state('carterror', {
        parent: 'general',
        url: '/carterror',
        views: {
            'main@root': {
                component: 'cartError'
            }
        },
        data: {
            public: true
        }
    });
}]).component('checkoutCart', _cart.cartComponent).component('checkoutConfirmation', _confirmation.cartConfirmationComponent).component('checkoutOrder', _order.orderComponent).component('cartProduct', _cartProduct.cartProductComponent).component('cartBySellers', _cartBySellers.cartBySellersComponent).component('cartError', _cartError.cartErrorComponent).component('cartTotalPriceDiscounts', _cartTotalPriceDiscounts.cartTotalPriceDiscountsComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/checkout/index.js
// module id = 909
// module chunks = 0